import * as React from 'react';
import { put } from 'redux-saga/effects';
import { FormattedMessage } from 'react-intl';

import { yieldSuccessNotification, yieldErrorNotification, yieldInfoNotification } from '@/lib/toasts';
import { addUiDeferredToastAction } from '@/domain/ui';
import { DeferredToastFactory } from '@/domain/ui/helpers';
import { isMobile } from '@/lib/systemHelpers/browserHelpers';

import { PostAction } from '@/domain/approvals/navigation/decideNavigation';

type ToastType = 'success' | 'error' | 'info';

interface ToastMessage {
  id: string;
  defaultMessage: string;
}

const inlineByType: Record<ToastType, (node: React.ReactNode) => void> = {
  success: yieldSuccessNotification,
  error: yieldErrorNotification,
  info: yieldInfoNotification,
};

export function* yieldToastForPostAction(
  postAction: PostAction,
  type: ToastType,
  message: ToastMessage,
): Generator<unknown, void, unknown> {
  // Inline path for `stay` (no navigation will happen) and for mobile (where
  // `applyPostActionNavigation` is a no-op). Deferred toasts are processed
  // by `deferredToastMiddleware` only on router `completeAction`; on mobile
  // the saga doesn't trigger router navigation, so a deferred toast would
  // get stuck in the queue and never display.
  if (postAction === 'stay' || isMobile) {
    inlineByType[type](<FormattedMessage id={message.id} defaultMessage={message.defaultMessage} />);
    return;
  }

  yield put({
    type: addUiDeferredToastAction.type,
    payload: DeferredToastFactory({ type, message }),
  });
}
